import { RequestLog } from '@engine/models'

import { ActivityTimeline } from '#components/ActivityTimeline'
import { EmptyState } from '#components/EmptyState'
import { ErrorsSection } from '#components/ErrorsSection'
import { KeyValueDisplay } from '#components/KeyValueDisplay'
import { RequestLogSections } from '#components/RequestLogSections'
import { formatDateTime } from '#utils/format'

import { QuoteStatusBadge } from './QuoteStatusBadge.jsx'

interface QuoteDetailsProps {
  quote: RequestLog | null
}

const QuoteDetails = ({ quote }: QuoteDetailsProps) => {
  if (!quote) {
    return <EmptyState title="Select a volume quote to view details" />
  }

  const responseContent = quote.tenantResponse?.content as any
  const rate = responseContent?.rates?.[0]
  const errorType = rate?.errorType || quote.tenantResponse?.content?.errorType
  const errors = rate?.errors || quote.tenantResponse?.content?.errors || []
  const rateCount = responseContent?.rates?.length || 0

  return (
    <div className="space-y-6">
      {/* Overview Section */}
      <KeyValueDisplay
        items={[
          { label: 'External ID', value: quote.externalId },
          { label: 'Request ID', value: quote.requestId },
          { label: 'Tenant ID', value: quote.tenantId },
          { label: 'Type', value: quote.type },
          {
            label: 'Carriers',
            value: quote.carrierCode?.join(', ').toUpperCase() || 'N/A',
          },
          {
            label: 'Rate Count',
            value: rateCount > 0 ? rateCount : 'No rates returned',
          },
          {
            label: 'Request Date',
            value: formatDateTime(quote.tenantRequest?.requestDate),
          },
          {
            label: 'Status',
            value: <QuoteStatusBadge log={quote} />,
          },
          ...(errorType ? [{ label: 'Error Type', value: errorType }] : []),
        ]}
      />

      {/* Errors Section */}
      <ErrorsSection
        errors={errors}
        errorType={errorType}
        carrier={quote.carrierCode?.[0]}
        requestId={quote.requestId}
        externalId={quote.externalId}
        service="rating"
      />

      <RequestLogSections requestLog={quote} />

      {/* Activity Timeline */}
      <ActivityTimeline
        externalId={quote.externalId}
        requestLogType="rates"
        emptyMessage="No traces or request logs found for this volume quote."
      />
    </div>
  )
}

export { QuoteDetails }
